export enum commentType {
  angel = "angel",
  dream = "dream",
  charity = "charity",
}
